/**
 * Helper method to grab the requested environment variable from the window object
 * Check if the environment variable is on the window object first before *using process.env
 *
 * @param environmentVariablePath
 */
const getEnvVar = environmentVariablePath => {
  if (typeof window !== 'undefined') {
    const windowEnvVar = window.ENV_DATA?.[environmentVariablePath];
    if (windowEnvVar) {
      return windowEnvVar;
    }
  }

  return process.env[environmentVariablePath];
};

export default getEnvVar;
